import React, { useState } from "react";
import { FileText, ChevronDown, ChevronUp } from "lucide-react";
import { ANSOKAN_SECTIONS } from "@/lib/ansokanMall";

export const CaseApplication = ({ application }) => {
  const [open, setOpen] = useState(true);
  if (!application || Object.keys(application).length === 0) return null;
  const filled = ANSOKAN_SECTIONS.filter((s) => application[s.key]);
  return (
    <div className="mt-6" data-testid="case-application">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between text-left">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-zinc-500">
          <FileText className="w-4 h-4 text-blue-700" /> Ansökan – AI-optimerad mall ({filled.length}/10 sektioner)
        </div>
        {open ? <ChevronUp className="w-4 h-4 text-zinc-400" /> : <ChevronDown className="w-4 h-4 text-zinc-400" />}
      </button>
      {open && (
        <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
          {filled.map((s) => (
            <div key={s.key} className="border border-zinc-200 rounded-sm p-3 bg-zinc-50/50">
              <div className="text-xs font-semibold text-zinc-700">{s.title}</div>
              <p className="mt-1 text-sm text-zinc-700 leading-relaxed whitespace-pre-line">{application[s.key]}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CaseApplication;
